import { render, staticRenderFns } from "./OBLWWTXW.vue?vue&type=template&id=56a19049&scoped=true"
import script from "./OBLWWTXW.vue?vue&type=script&lang=js"
export * from "./OBLWWTXW.vue?vue&type=script&lang=js"
import style0 from "./OBLWWTXW.vue?vue&type=style&index=0&id=56a19049&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a19049",
  null
  
)

export default component.exports